/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 投与薬剤
 */
export type AdministeredMedication =
  (typeof AdministeredMedication)[keyof typeof AdministeredMedication];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdministeredMedication = {
  ADRENALINE: 'ADRENALINE',
  GLUCOSE: 'GLUCOSE',
  EPINEPHRINE: 'EPINEPHRINE',
} as const;
